import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import logo from "../../assets/affiliate/clapingo-afiliate.svg";
import logo2 from "../../assets/affiliate/clapingo-afiliate.svg";
import { scrollTop } from "../../helpers/PageHelper";

const NavComponent = () => {

    const history = useHistory();
  
  useEffect(() => {
    let scrollpos = window.scrollY;
    const header = document.querySelector("header");
    const logo1 = document.querySelector("#logo1");
    const logo2 = document.querySelector("#logo2");
    const bar = document.querySelector("#bar");
    const header_height = header.scrollHeight;

    const add_class_on_scroll = () => {
      header.classList.add("navbar_fixed");
      logo1.classList.add("logo_display");
      logo2.classList.remove("logo_display");
      bar.classList.remove("bar_color");
    };
    const remove_class_on_scroll = () => {
      header.classList.remove("navbar_fixed");
      logo2.classList.add("logo_display");
      bar.classList.add("bar_color");
      logo1.classList.remove("logo_display");
    };

    window.addEventListener("scroll", function () {
      scrollpos = window.scrollY;
      if (scrollpos >= header_height) {
        add_class_on_scroll();
      } else {
        remove_class_on_scroll();
      }
    });
  }, []);


  const renderListLeft = () => {
    return [
      <li
        className="nav-item "
        onClick={scrollTop}
        data-toggle={window.innerWidth < 992 ? "collapse" : ""}
        data-target="#navbarSupportedContent"
        key="1"
      >
          <div className="signin mb-2 mt-2 mb-md-0" onClick={() =>{history.push('/affiliate/login')}}>
            Log in 
          </div>
      </li>
    ];
  };

  return (
    <>
      <header className="header_area ">
        <div className="main_menu">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container">
              <Link to="/" id="logo1">
                <img
                  src={logo}
                  className="logo mt-3 ml-3 ml-md-0"
                  alt="clapingo_logo"
                  style={{width:"13rem"}}
                  onClick={scrollTop}
                />
              </Link>
              <Link
                to="/"
                className="logo_display"
                id="logo2"
                onClick={scrollTop}
              >
                <img
                  src={logo2}
                  className="logo m-2 m-md-0 "
                  alt="clapingo_logo"
                  style={{width:"13rem"}}
                />
              </Link>

              <button
                className="navbar-toggler bar_color"
                id="bar"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className=" fas fa-bars"></span>
              </button>
              <div
                className="collapse navbar-collapse offset"
                id="navbarSupportedContent"
              >
                <ul className="nav navbar-nav menu_nav justify-content-center">
                  {/* {renderListRight()} */}
                </ul>
                <ul className="nav navbar-nav justify-content-end">
                  {renderListLeft()}
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default NavComponent;
